import React from "react";
import { siteConfig } from "../config/siteConfig";
import "../css/contactus.scss";

function Contact() {
  const mapHref = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    siteConfig.contact.address.join(", ")
  )}`;

  return (
    <main id="main-content" className="contact-page">
      <figure className="contact-page__image">
        <img
          src="/img/contact-space.jpg"
          alt="A calm contemporary interior in Hong Kong"
          width="1120"
          height="1400"
          decoding="async"
        />
        <figcaption>{siteConfig.tagline}</figcaption>
      </figure>

      <header className="contact-page__intro" aria-labelledby="contact-title">
        <p className="contact-page__eyebrow">Contact</p>
        <h1 id="contact-title">Come and say hello.</h1>
        <p>
          Visit the studio, ask about an object or simply begin a conversation.
          We will get back to you as soon as we can.
        </p>
      </header>

      <section className="contact-page__details" aria-label="Contact information">
        <div className="contact-page__directory">
          <section aria-labelledby="visit-title">
            <p className="contact-page__number" aria-hidden="true">
              01
            </p>
            <div>
              <h2 id="visit-title">Visit</h2>
              <address>
                {siteConfig.contact.address.map((line) => (
                  <React.Fragment key={line}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </address>
              <a href={mapHref} target="_blank" rel="noreferrer">
                View on map <span aria-hidden="true">↗</span>
              </a>
            </div>
          </section>

          <section aria-labelledby="hours-title">
            <p className="contact-page__number" aria-hidden="true">
              02
            </p>
            <div>
              <h2 id="hours-title">Opening hours</h2>
              <p>{siteConfig.contact.openingHours}</p>
              <p>Please contact us before making a special journey.</p>
            </div>
          </section>

          <section aria-labelledby="write-title">
            <p className="contact-page__number" aria-hidden="true">
              03
            </p>
            <div>
              <h2 id="write-title">Write to us</h2>
              <p>
                <a href={`mailto:${siteConfig.contact.email}`}>
                  {siteConfig.contact.email}
                </a>
              </p>
            </div>
          </section>
        </div>
      </section>
    </main>
  );
}

export default Contact;
